import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { psoResultsLevels } from 'common/enums';
import { PsoResultsState, MasterFilterState, DetailFilterState, Scenario, MappedFileGroups } from './types';


const initialState: PsoResultsState = {
    // spinners
    masterSpinner: false,
    detailSpinner: false,
    // sources
    masterSource: {
        data: [],
        filter: {
            pageSize: 10,
            pageNumber: 1,
            searchString: '',
            taskId: 0,
        },
    },
    detailSource: {
        data: [],
        filter: {
            searchString: '',
            scenarioId: 0,
        },
    },
    // selections
    masterSelected: [],
    detailSelected: [],
    masterLevel: psoResultsLevels.cases,
    detailLevel: psoResultsLevels.files,
    reportsSpinner: false,
    hasTemplate: false,
};

const psoResultsSlice = createSlice({
    name: 'psoResults',
    initialState,
    reducers: {
        toggleMasterSpinner(state, action: PayloadAction<boolean>) {
            state.masterSpinner = action.payload;
        },
        toggleDetailSpinner(state, action: PayloadAction<boolean>) {
            state.detailSpinner = action.payload;
        },
        changeMasterSelection(state, action: PayloadAction<number[]>) {
            state.masterSelected = action.payload;
        },
        changeDetailSelection(state, action: PayloadAction<string[]>) {
            state.detailSelected = action.payload;
        },
        setBaseInfo(state, action: PayloadAction<{ hasTemplate: boolean }>) {
            state.hasTemplate = action.payload.hasTemplate;
        },
        setMasterSource(state, action: PayloadAction<{ data: Scenario[]; total?: number }>) {
            state.masterSource.data = action.payload.data;
            state.masterSource.total = action.payload.total;
        },
        setDetailSource(state, action: PayloadAction<{ data: MappedFileGroups[]; total?: number }>) {
            state.detailSource.data = action.payload.data;
            state.detailSource.total = action.payload.total;
        },
        setMasterFilter(state, action: PayloadAction<Partial<MasterFilterState>>) {
            state.masterSource.filter = {
                ...state.masterSource.filter,
                ...action.payload,
            };
        },
        setDetailFilter(state, action: PayloadAction<Partial<DetailFilterState>>) {
            state.detailSource.filter = {
                ...state.detailSource.filter,
                ...action.payload,
            };
        },
        reset(state) {
            state = initialState;
        }
    }
});

export const actions = psoResultsSlice.actions;
export default psoResultsSlice.reducer;
